var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "parent",
      staticClass: "pop-menu-parent",
      on: {
        click: _vm.handleClick,
        dblclick: _vm.onDblclick,
        mouseenter: _vm.mouseEnter,
        mouseleave: _vm.mouseLeave,
        mousemove: _vm.mouseMove,
      },
    },
    [
      _vm.popover
        ? _c(
            "div",
            {
              staticClass: "pop-menu",
              style: { left: _vm.left, top: _vm.top },
            },
            [
              _c("div", { staticClass: "rect" }),
              _vm._v(" "),
              _vm.filterAdd
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            zIndex: 9999999999,
                          },
                          expression:
                            "{\n                followCursor: true,\n                placement: 'bottom-end',\n                zIndex: 9999999999,\n            }",
                        },
                      ],
                      staticClass: "popover-item",
                      attrs: { content: "Filtreye Ekle" },
                      on: { click: _vm.addFilter },
                    },
                    [
                      _c("search-add", {
                        tag: "component",
                        attrs: { color: "white" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterRemove
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            zIndex: 9999999999,
                          },
                          expression:
                            "{\n                followCursor: true,\n                placement: 'bottom-end',\n                zIndex: 9999999999,\n            }",
                        },
                      ],
                      staticClass: "popover-item",
                      attrs: { content: "Filtreden Çıkar" },
                      on: { click: _vm.removeFilter },
                    },
                    [
                      _c("search-remove", {
                        tag: "component",
                        attrs: { color: "white" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.copy
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            zIndex: 9999999999,
                          },
                          expression:
                            "{\n                followCursor: true,\n                placement: 'bottom-end',\n                zIndex: 9999999999,\n            }",
                        },
                      ],
                      staticClass: "popover-item",
                      attrs: { content: "Kopyala" },
                      on: { click: _vm.copyText },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("content_copy"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }